import React from 'react';

const solutions = [
  {
    title: "Energia Solar para Empresas",
    desc: "Reduza o custo fixo do seu negócio com sistemas robustos e alta durabilidade.",
    icon: (
      <svg className="w-8 h-8 text-[#39B54A]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    image: "https://i.imgur.com/enHl71N.jpeg"
  },
  {
    title: "Usinas Fotovoltaicas",
    desc: "Projetos de grande porte para investidores e geração distribuída em larga escala.",
    icon: (
      <svg className="w-8 h-8 text-[#39B54A]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    image: "https://i.imgur.com/R7uJGcU.jpeg"
  },
  {
    title: "Projetos sob Medida",
    desc: "Análise técnica personalizada para garantir o melhor retorno sobre o investimento.",
    icon: (
      <svg className="w-8 h-8 text-[#39B54A]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    image: "https://i.imgur.com/9iaEZ8I.jpeg"
  },
  {
    title: "Manutenção e Suporte",
    desc: "Assistência técnica especializada e monitoramento para máxima performance.",
    icon: (
      <svg className="w-8 h-8 text-[#39B54A]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37a1.724 1.724 0 002.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    image: "https://i.imgur.com/enHl71N.jpeg"
  }
];

const Solutions: React.FC = () => {
  return (
    <section id="solucoes" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <h2 className="text-xs font-black tracking-[0.2em] text-[#39B54A] mb-4">Soluções</h2>
          <h3 className="text-4xl md:text-5xl font-black text-gray-900">Inovação tecnológica em cada detalhe do projeto.</h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {solutions.map((sol, idx) => (
            <div key={idx} className="group relative bg-white border border-gray-100 rounded-3xl overflow-hidden transition-all hover:scale-[1.02] duration-500 hover:shadow-2xl">
              <div className="h-48 overflow-hidden">
                <img src={sol.image} alt={sol.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 opacity-80 group-hover:opacity-100" />
              </div>
              <div className="p-8 space-y-4">
                <div className="p-3 bg-gray-50 inline-block rounded-2xl group-hover:bg-[#39B54A]/10 transition-colors">
                  {sol.icon}
                </div>
                <h4 className="text-xl font-black text-gray-900">{sol.title}</h4>
                <p className="text-gray-500 text-sm font-medium leading-relaxed">{sol.desc}</p>
              </div>
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#39B54A]/10 rounded-3xl pointer-events-none transition-colors"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;